import { useContext } from 'react';
import { StandortContext } from './StandortContext';

export const useStandort = () => {
  const context = useContext(StandortContext);
  if (!context) {
    throw new Error('useStandort muss innerhalb von StandortProvider verwendet werden');
  }
  return context;
};
